import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule, Title} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {routes} from './app-routes';
import {AppComponent} from './app.component';
import {DandPCoreModule} from './modules/core/dandp-core.module';
import {BsDropdownModule} from 'ngx-bootstrap';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {StoreModule} from '@ngrx/store';
import { reducers, metaReducers} from './app.reducer';
import {RouterModule} from '@angular/router';
import {AppMenuComponent} from './app-menu';
import {DandpDocumentModule} from './modules/document/dandp-document.module';
import {environment} from '../environments/environment';
import {DandPBreadcrumbComponent} from './app-breadcrumb';
import {StartPageComponent} from './containers/start-page';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule, RouterStateSerializer } from '@ngrx/router-store';
import { CustomRouterStateSerializer } from 'app/app.router-state';
import { IrarModule } from './modules/irar/irar.module';
import { CoreAdminContainerComponent } from './containers/core-admin';


@NgModule({
  declarations: [
    AppComponent,
    AppMenuComponent,
    DandPBreadcrumbComponent,
    StartPageComponent,
    CoreAdminContainerComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    HttpModule,
    RouterModule.forRoot(routes),
    DandPCoreModule,
    DandpDocumentModule,
    BsDropdownModule.forRoot(),
    StoreModule.forRoot(reducers, { metaReducers: metaReducers}),
    EffectsModule.forRoot([]),
    StoreRouterConnectingModule.forRoot({
      stateKey: 'router'
    }),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    IrarModule
  ],
  providers: [
    {
      provide: 'ApplicationConfig',
      useValue: environment
    },
    { provide: RouterStateSerializer, useClass: CustomRouterStateSerializer },
    Title
    ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() { }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/app.module.ts